<div (click)="parentEventEmitter($event)">
  <app-side-menu></app-side-menu>
  <router-outlet></router-outlet>
  <app-loader></app-loader>
</div>

<div *ngIf="checkTokenExists()">
  <app-livechat-smart [iconType]="chatBotIconType"></app-livechat-smart>
</div>
